import React, {useState, useEffect} from 'react';
import { Select } from 'antd';

const { Option } = Select;

export const TimezoneDropdown = (props) => {
    const {choosenTimezone, timezones, timezoneName, handleTimezoneChange} = props;
    const [curTimeZoneName, setCurTimeZoneName] = useState(timezoneName);
    const [displayValue, setDisplayValue] = useState("Choose timezone");

    useEffect(() => {
        if (choosenTimezone) {
            if (curTimeZoneName === "Berlin") {
                setDisplayValue(timezones["CEST2"]);
            } else if (curTimeZoneName === "Amsterdam") {
                setDisplayValue(timezones["CEST"]);
            } else {
                setDisplayValue(timezones[choosenTimezone]);
            }
        } else {
            setDisplayValue("Choose timezone");
        }
    }, [choosenTimezone, curTimeZoneName, timezones]);

    const handleChange = (value) => {
        handleTimezoneChange(value);
        setCurTimeZoneName(value);
    };

    return (
        <div>
            <h3 className="modal-category mb-2">Select your timezone</h3>
            <p>Which timezone is applicable for your business?</p>
            <div>
                <Select
                    style={{ width: '100%', maxWidth: '300px' }}
                    placeholder="Choose timezone"
                    value={choosenTimezone}
                    onChange={handleChange}
                    popupClassName="custom-dropdown"
                >
                    {Object.keys(timezones).map(key => (
                        <Option key={key} value={key}>
                            {timezones[key]}
                        </Option>
                    ))}
                </Select>
            </div>
        </div>
    );
};